import { ALL_COMPARATORS, type ComparatorType } from './comparators';

export const ALL_OPERATORS_CONFIG: {
  [key in ComparatorType]: {
    value: ComparatorType;
    label: string;
  };
} = {
  [ALL_COMPARATORS.is]: {
    value: 'is',
    label: 'Is',
  },
  [ALL_COMPARATORS.is_not]: {
    value: 'is_not',
    label: 'Is Not',
  },
  [ALL_COMPARATORS.less_than_or_equal_to]: {
    value: 'less_than_or_equal_to',
    label: 'Less Than or Equal To',
  },
  [ALL_COMPARATORS.greater_than_or_equal_to]: {
    value: 'greater_than_or_equal_to',
    label: 'Greater Than or Equal To',
  },
  [ALL_COMPARATORS.between]: {
    value: 'between',
    label: 'Between',
  },
  [ALL_COMPARATORS.is_not_defined]: {
    value: 'is_not_defined',
    label: 'Is Not Defined',
  },
  [ALL_COMPARATORS.is_defined]: {
    value: 'is_defined',
    label: 'Is Defined',
  },
  [ALL_COMPARATORS.contain]: {
    value: 'contain',
    label: 'Contains',
  },
  [ALL_COMPARATORS.does_not_contain]: {
    value: 'does_not_contain',
    label: 'Does Not Contain',
  },
  [ALL_COMPARATORS.contains_data]: {
    value: 'contains_data',
    label: 'Contains Data',
  },
  [ALL_COMPARATORS.does_not_contain_data]: {
    value: 'does_not_contain_data',
    label: 'Does Not Contain Data',
  },
  [ALL_COMPARATORS.starts_with]: {
    value: 'starts_with',
    label: 'Starts With',
  },
  [ALL_COMPARATORS.ends_with]: {
    value: 'ends_with',
    label: 'Ends With',
  },
  [ALL_COMPARATORS.before]: {
    value: 'before',
    label: 'Before',
  },
  [ALL_COMPARATORS.after]: {
    value: 'after',
    label: 'After',
  },
  [ALL_COMPARATORS.is_true]: {
    value: 'is_true',
    label: 'Is True',
  },
  [ALL_COMPARATORS.is_false]: {
    value: 'is_false',
    label: 'Is False',
  },
  [ALL_COMPARATORS.changed_to]: {
    value: 'changed_to',
    label: 'Changed To',
  },
  [ALL_COMPARATORS.changed_from_to]: {
    value: 'changed_from_to',
    label: 'Changed (From - To)',
  },
  [ALL_COMPARATORS.yesterday]: {
    value: 'yesterday',
    label: 'Yesterday',
  },
  [ALL_COMPARATORS.today]: {
    value: 'today',
    label: 'Today',
  },
  [ALL_COMPARATORS.tomorrow]: {
    value: 'tomorrow',
    label: 'Tomorrow',
  },
  [ALL_COMPARATORS.last_week]: {
    value: 'last_week',
    label: 'Last Week',
  },
  [ALL_COMPARATORS.this_week]: {
    value: 'this_week',
    label: 'This Week',
  },
  [ALL_COMPARATORS.next_week]: {
    value: 'next_week',
    label: 'Next Week',
  },
  [ALL_COMPARATORS.last_month]: {
    value: 'last_month',
    label: 'Last Month',
  },
  [ALL_COMPARATORS.this_month]: {
    value: 'this_month',
    label: 'This Month',
  },
  [ALL_COMPARATORS.next_month]: {
    value: 'next_month',
    label: 'Next Month',
  },
  [ALL_COMPARATORS.last_n_days]: {
    value: 'last_n_days',
    label: 'Last N Days',
  },
  [ALL_COMPARATORS.next_n_days]: {
    value: 'next_n_days',
    label: 'Next N Days',
  },
  [ALL_COMPARATORS.last_n_hours]: {
    value: 'last_n_hours',
    label: 'Last N Hours',
  },
  [ALL_COMPARATORS.custom]: {
    value: 'custom',
    label: 'Custom',
  },
  [ALL_COMPARATORS.all_time]: {
    value: 'all_time',
    label: 'All Time',
  },
};
